
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class NewsletterDialog extends Serenity.EntityDialog<NewsletterRow, any> {
        protected getFormKey() { return NewsletterForm.formKey; }
        protected getIdProperty() { return NewsletterRow.idProperty; }
        protected getLocalTextPrefix() { return NewsletterRow.localTextPrefix; }
        protected getNameProperty() { return NewsletterRow.nameProperty; }
        protected getService() { return NewsletterService.baseUrl; }
        protected getDeletePermission() { return NewsletterRow.deletePermission; }
        protected getInsertPermission() { return NewsletterRow.insertPermission; }
        protected getUpdatePermission() { return NewsletterRow.updatePermission; }

        protected form = new NewsletterForm(this.idPrefix);

        constructor() {
            super();
            this.form.PageTemplates.change(function () {
                alert("Handler for .change() called.");
            }); 


            this.form.PageTemplates.element.bind('dialogclose', () => {
                // *** This is triggered after closing dialog ***
                alert("Handler for .dialogclose() called.");
            });
            this.form.PageTemplates.element.bind('changeme', () => {
                // *** This is triggered after closing dialog ***
                alert("Handler for .changeme() called.");
            });
            this.form.PageTemplates.element.bind('change', () => {
                // *** This is triggered after closing dialog ***
                alert("Handler for .change() called.");
            });

        } 

        public changeme() {
            Q.alert("tester");
        }

    }
}